import { registerView, View, ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useCallback } from "react";
import { Form } from "react-bootstrap";
import FuelTypeViewModel from "viewModels/eshop/order/steps/fuelTypeViewModel";
import AlertWithInfoIcon from "views/common/alertWithInfoIcon/alertWithInfoIcon";
import TextWithLink from "views/common/textWithLink/textWithLink";
import ChargeTypeVehicleInfo from "../components/chargeTypeVehicleInfo";
import { StepsNavigationButtons } from "../components/stepsNavigationButtons";

const FuelTypeView: ViewComponent<FuelTypeViewModel> = observer(({ vm }) => {
  const tg = (value: string) => vm.localizationService.translateGeneral(`eshop.order.${value}`);
  const formRef = useCallback(node => {
    if (node !== null) {
      vm.formElement = node;
    }
  }, []);

  return (
    <>
      <div>
        <Form ref={formRef}>
          <View vm={vm.fuelTypeSelectViewModel} />
        </Form>
        {vm.fuelTypeLimitation && (
          <AlertWithInfoIcon variant="warning">
            <div>
              <TextWithLink
                text={vm.translateFuelTypeLimitation(vm.fuelTypeLimitation).replace("%FUEL_TYPE%", vm.fuelType)}
                link={vm.translateFuelTypeLimitationLink(vm.fuelTypeLimitation)}
              />
            </div>
          </AlertWithInfoIcon>
        )}
        {vm.showInfoAboutVehicles && (
          <ChargeTypeVehicleInfo
            title={vm.translateInfoAboutVehicle("title")}
            markdownText={vm.translateInfoAboutVehicle("text")}
          />
        )}
      </div>
      <StepsNavigationButtons tg={tg} onBack={() => vm.onBack()} onContinue={() => vm.onContinue()} />
    </>
  );
});

registerView(FuelTypeView, FuelTypeViewModel);
